/** @jsx jsx */
import { jsx } from "theme-ui"
import CookieConsent from "react-cookie-consent"
import Header from "./header"
import Footer from "./footer"

import "../styles/main.scss"

const Layout = ({ children, className, props }) => {
  return (
    <div className="primary-container">
      <CookieConsent
        location="bottom"
        onAccept={() => {
          alert("Thank you for accepting our 🍪🍪🍪's");
        }}
        buttonText="Accept"
        enableDeclineButton
        onDecline={() => {
          alert("nay!");
        }}
        declineButtonText="Decline"
        cookieName="gatsby-gdpr-google-analytics"
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={150}
      >
        This website uses cookies to enhance the user experience.{" "}
      </CookieConsent>
      <Header />
      <main className={"container " + className}>{children}</main>
      <Footer />
    </div>
  )
}

export default Layout

//COOKIES
//https://stackoverflow.com/questions/59860068/how-set-up-a-gatsby-cookie-consent-banner-with-gatsby-plugin-gdpr-c

//https://www.gatsbyjs.com/plugins/gatsby-plugin-gdpr-cookies/

//https://www.npmjs.com/package/react-cookie-consent
